import React from "react";
import styles from "./Card.module.scss";
import classNames from "classnames";
import { ReactComponent as SelectedIcon } from "./../../images/monochrome-icons/ic-card-selected.svg"
import _ from "lodash";

export const Card = ({children, className, style, selected, hasHoverEffect, Component = "div", ...rest}) => {
    return <Component className={classNames(styles.base, className, {[styles['selected']]: selected, [styles['has-hover-effect']]: hasHoverEffect})} style={style} {...rest}>
        {selected && <SelectedIcon className={styles['selected-icon']}/>}
        {children}
    </Component>
};

export const CardHeader = ({children, type = "large", className, style}) => {
    return <div className={classNames(styles.header, styles[type], className)} style={style}>
        {children}
    </div>
}

export const CardContent = ({children, className, style}) => {
    return <div className={classNames(styles.content, className)} style={style}>
        {children}
    </div>
}

export const CardTitle = ({children, className, style, SubHeader}) => {
    const isString = _.isString(children);
    return <div className={classNames(styles.title, className)} style={style} title={isString ? children : undefined}>
        {children}
        {SubHeader && <div className={styles['sub-header']}>{SubHeader}</div>}
    </div>
}

export const CardTableContent = ({children, className, style, columns = "lg-3"}) => {
    return <div className={classNames(styles['table-content'], styles[columns], className)} style={style}>
        {children}
    </div>
}

export const CardTableItem = ({children}) => {
    return <div className={styles['table-item']}>
        <div>
            {children}
        </div>
    </div>
}
